import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { darkTheme } from '@stylesheets/theme';
import LoginLayout from '@components/1-atoms/Layouts/LoginLayout/LoginLayout';
import Button, { BUTTON_VARIANT_TEXT } from '@components/1-atoms/Button';
import PageHeader, { PAGE_HEADER_VARIANT_LARGE } from '@components/2-molecules/PageHeader';
import { ErrorBox } from '../auth.styled';
import { Header, Logo, BrandName, LoginForm, LoginStepContent } from '../Login/Login.styled';

export interface SsoStatusProps {
  title: string;
  subtitle: string;
  error: string | null;
}

const SsoStatus: React.FC<SsoStatusProps> = ({ title, subtitle, error }) => {
  const navigate = useNavigate();

  return (
    <ThemeProvider theme={darkTheme}>
      <LoginLayout>
        <Header>
          <Logo />
          <BrandName>Aibuild OS</BrandName>
        </Header>
        <LoginForm as="div">
          <LoginStepContent>
            <PageHeader
              variant={PAGE_HEADER_VARIANT_LARGE}
              title={error ? 'Sign-in failed' : title}
              subtitle={error ? undefined : subtitle}
            />
            {error && (
              <>
                <ErrorBox>{error}</ErrorBox>
                <Button variant={BUTTON_VARIANT_TEXT} onClick={() => navigate('/auth/login')}>
                  Back to log in
                </Button>
              </>
            )}
          </LoginStepContent>
        </LoginForm>
      </LoginLayout>
    </ThemeProvider>
  );
};

export default SsoStatus;
